const React = require('react');
const { wrapFunctionalComponent } = require('utils/framework').default;
const getBaseComponent = require('utils/framework/getBaseComponent').default;
const getStyledComponent = require('utils/framework/getStyledComponent').default;
const { compose, border, space, system } = require('styled-system');
const theme = require('style/theme').default;

const display = system({ display: { property: 'display' } });

const StyledDiv = getStyledComponent({
    InnerComp: getBaseComponent({ elementType: 'div' }),
    styledProps: [compose(display, border, space), props => props.css]
});
// const StyledDiv = styled('div', { shouldForwardProp })();

function Divider({ color, height, thick, ...props }) {
    let borderBottom = height;
    let borderColor = color;

    if (thick) {
        borderBottom = 3;
        borderColor = 'nearWhite';
    }

    return (
        <StyledDiv
            borderBottom={borderBottom}
            borderColor={borderColor}
            {...props}
        />
    );
}

Divider.defaultProps = {
    theme,
    height: 1,
    color: 'divider'
};

module.exports = wrapFunctionalComponent(Divider, 'Divider');
